<template>
  <component
    :is="category.enabled ? 'a' : 'div'"
    :href="categorySlug(category)"
    :class="{
      'fact-finder-category-fi': true,
      'fact-finder-category-fi--disabled': !category.enabled,
    }"
    @click.capture.stop="(event: MouseEvent) => onClick(event, category)"
  >
    <div class="fact-finder-category-fi__name">
      {{ category.name }}
    </div>

    <icon-fi
      v-if="category.enabled"
      class="fact-finder-category-fi__icon"
      icon="chevron-up"
    />
  </component>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';

import type { BreadCrumbItem } from '@/components/atoms/breadcrumb-fi/BreadcrumbFi.vue';
import { useEventHub } from '@/composables/eventHub';
import { useFischer } from '@/composables/fischerPlugin';
import { useNavigationStore } from '@/store/pinia/navigation';

import type {
  SearchFactFinderCategory,
  SearchFactFinderSubCategory,
} from '../../SearchFactFinderResultsFi.vue';

defineOptions({
  name: 'FactFinderCategoryFi',
});

const navigationStore = useNavigationStore();
const fischer = useFischer();
const { sendClickToEventHub } = useEventHub();

const props = defineProps<{
  category: SearchFactFinderCategory;
  filterUrlParams?: string;
}>();

const categorySlug = (category: SearchFactFinderCategory | SearchFactFinderSubCategory) => {
  if (!props.category.enabled) {
    return undefined;
  }
  const products = fischer.pages.products().url;
  return `${products}${category.Slug}${props.filterUrlParams}`;
};

const onClick = (
  event: MouseEvent,
  category: SearchFactFinderCategory | SearchFactFinderSubCategory,
) => {
  if (!category.enabled || event.detail === 2) {
    return;
  }
  const slug = categorySlug(category);
  if (!slug) {
    console.error('missing category slug');
    return;
  }
  const productBreadcrumb = navigationStore.productBreadcrumb;
  const breadcrumb = productBreadcrumb.map((item: BreadCrumbItem) => item.title);
  breadcrumb.unshift('[category]:');
  breadcrumb.push(props.category.name);
  const eventQuery = breadcrumb.join('/');
  sendClickToEventHub(
    {
      clickSource: 'category',
      familyId: props.category.id,
      pageTitle: props.category.name,
      query: eventQuery,
      url: window.location.href,
    },
    event,
    slug,
  );
};
</script>

<style scoped src="./fact-finder-category-fi" />
